<!-- Toast Container -->
@if (visible) {
  <div [@slideIn] [id]="'toast-' + data.type" [ngClass]="getToastClasses()" [attr.role]="role"
    (mouseenter)="onPointerEnter()" (mouseleave)="onPointerLeave()"
    (focusin)="onFocusIn()" (focusout)="onFocusOut($event)">
    <div class="toast-main">
      <div class="toast-content">
        <!-- Dynamic Icon -->
        <svg class="toast-icon" xmlns="http://www.w3.org/2000/svg" fill="none"
          viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" [attr.d]="getIconPath()" />
        </svg>
        <!-- Message Content -->
        <div class="toast-message" [innerHTML]="data.text">
        </div>
      </div>
      <!-- Close Button -->
      <button type="button" (click)="close()" class="toast-button" aria-label="Close">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
          stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
    </div>
    <!-- Progress Bar -->
    @if (!persistent) {
      <div class="toast-progress-container" aria-hidden="true">
        <div class="toast-progress-bar" [style.animation-duration.ms]="getProgressDuration()"
          [style.animation-play-state]="paused() ? 'paused' : 'running'"></div>
      </div>
    }
  </div>
}